import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { AdminService } from '../../../admin/admin.service';
import {
  GridComponent,
  GridModule,
  KENDO_GRID_EXCEL_EXPORT,
} from '@progress/kendo-angular-grid';
import { ReportingService } from '../../reporting.service';
import { MatDialog } from '@angular/material/dialog';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-bridge-density',
  templateUrl: './bridge-density.component.html',
  styleUrls: ['./bridge-density.component.scss'],
  imports: [
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    GridModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    KENDO_GRID_EXCEL_EXPORT,
  ],
})
export class BridgeDensityComponent implements OnInit {
  private admnSvc = inject(AdminService);
  private rptSvc = inject(ReportingService);
  private dialog = inject(MatDialog);

  unitsControl = new FormControl();
  density = { unit: null, score: null };
  filteredUnits;
  selectedUnit;
  bridgeDensityData;

  ngOnInit(): void {
    this.bridgeDensityData = { data: null, headers: null };
    this.getUnits();
  }

  getBridgeDensity() {
    this.rptSvc
      .getBridgeDensity(this.density.unit, this.density.score)
      .subscribe({
        next: data => {
          this.bridgeDensityData = { ...data.results };
        },
        error: error => {
          console.error(error);
        },
      });
  }

  checkSelection() {
    if (
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return unit.id === this.unitsControl.value;
      })
    ) {
      this.unitsControl.setValue(null);
    }
  }

  getUnits() {
    this.unitsControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }

  exportToExcel(grid: GridComponent): void {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Disclosure',
        aiDisclosure: true,
        confirm: 'Agree and Download',
        cancel: 'Cancel/Exit',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        grid.saveAsExcel();
      }
      dialogRef = null;
    });
  }
}
